import { matchBreakpoint } from './match-breakpoint';
export const setup = () => {
	if (matchBreakpoint('xs')) {
		console.log(
			'Todo: handle video element loading, autoplay, loop and controls in media-text blocks'
		);
	}
};

const MODAL_SELECTOR = '[data-page-video-modal]';
const MODAL_BUTTON_SELECTOR = '[data-iframe-src]';

export const setupModalVideo = () => {
	const modalEl = document.querySelector(MODAL_SELECTOR);
	if (modalEl) {
		addVideoClickHandlers(modalEl);
	}
};

const addVideoClickHandlers = (modalEl) => {
	const buttonWrappers = document.querySelectorAll(MODAL_BUTTON_SELECTOR);

	if (!buttonWrappers.length) {
		return;
	}

	const modal = setupModal(modalEl);
	buttonWrappers.forEach((wrapper) => {
		const src = wrapper.dataset.iframeSrc,
			button =
				wrapper.tagName === 'A' ? wrapper : wrapper.querySelector('a');

		button.setAttribute('href', src);
		addOnClickListener(button, modalEl, modal, src);
	});
};

const setupModal = (element) => {
	const modal = new bootstrap.Modal(element);
	addDismissHandler(element);
	return modal;
};

const addOnClickListener = (button, modalEl, modal, src) => {
	button.onclick = (e) => {
		e.preventDefault();
		const iframe = modalEl.querySelector('iframe');
		iframe.setAttribute('src', src);
		modal.show();
	};
};

const addDismissHandler = (modal) => {
	const wrapper = modal.querySelector('.iframe-wrapper');
	const html = wrapper.innerHTML;
	modal.addEventListener('hidden.bs.modal', (e) => {
		wrapper.innerHTML = html;
		const iframe = modal.querySelector('iframe');
		iframe.setAttribute('src', '');
	});
};
